import React, { useState } from 'react';
import PropTypes from 'prop-types';
import PrimaryButtonComponent from '../../../Components/Buttons/PrimaryButton/PrimaryButton.component';
import { httpVerifyDiscount } from '../../../Hooks/discount/discount.hooks';

const DiscountCode = ({
  setDiscountAmount,
  setDiscountCode,
  discountCode = '',
  companyId = '',
}) => {
  const [discountCodeApplied, setDiscountCodeApplied] = useState(null);

  const fetchDiscount = async (e) => {
    e.preventDefault();
    try {
      const res = await httpVerifyDiscount(discountCode, companyId);
      const data = await res.json();
      if (res.ok) {
        setDiscountAmount(data.amount);
        setDiscountCodeApplied(true);
      } else {
        setDiscountCodeApplied(false);
        setDiscountAmount(0);
        console.error('Error fetching discount:', data.msg);
      }
    } catch (err) {
      console.error('Error fetching discount:', err);
      setDiscountCodeApplied(false);
      setDiscountAmount(0);
    }
  };
  return (
    <aside className="discount">
      <h4>Discount Code</h4>
      {discountCodeApplied === true && (
        <>
          <p className="success">
            Discount code has been successfully applied!
          </p>
          <br />
        </>
      )}
      {discountCodeApplied === false && (
        <>
          <p className="error">Invalid coupon code. Please try again.</p>
          <br />
        </>
      )}
      <div>
        <input
          type="text"
          value={discountCode}
          onChange={(e) => setDiscountCode(e.target.value)}
          placeholder="Enter discount code"
        />
        <PrimaryButtonComponent span="Apply" functionName={fetchDiscount} />
      </div>
    </aside>
  );
};
DiscountCode.propTypes = {
  setDiscountAmount: PropTypes.func.isRequired,
  setDiscountCode: PropTypes.func.isRequired,
  discountCode: PropTypes.string.isRequired,
  companyId: PropTypes.string.isRequired,
};

export default DiscountCode;
